import React, { useMemo } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { QuickUserToggler } from "../extras/QuiclUserToggler";

export function Topbar(props) {
  const uiService = useHtmlClassService();
  
  const layoutProps = useMemo(() => {
    return {
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
    };
  }, [uiService]);

  return (
    <div className="topbar align-items-center c_header natTab">
      {layoutProps.viewUserDisplay && <QuickUserToggler language={props.language} themeData={props.themeData} translationsVersion={props.translationsVersion}/>}
    </div>
  );
}
